import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/atbCarouselsHomepage/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showAtbCarouselsHomepageSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showAtbCarouselsHomepageSelector };
